import AdminDrawer from './AdminDrawer';

export default AdminDrawer;
